module.exports = __webpack_public_path__ + "static/paypal-fb1ee2e1489dd9d8b4750f120df0b685.png";